/* eslint-disable */
const ls = require('local-storage');

import jwtDecode from 'jwt-decode';
import services from 'services';
import * as types from './mutation-types';


export default {
  fetchState: ({ dispatch }) => {
    const shopToken = ls.get('shopToken');
    if (shopToken) {
      dispatch('loginWithShopToken', shopToken);
      return shopToken;
    }
    return null;
  },
  loginWithShopToken: async ({ commit }, shopToken) => {
    commit(types.LOGIN, { shop: jwtDecode(shopToken), shopToken: shopToken });
  },
  /**
   * Adds shop to state and set state.authenticated value to true
   */
  handleMagicLinkToken: async ({ commit, dispatch, rootGetters }, token) => {
    try {
      const decoded = jwtDecode(token);
      await services.shopAuthService.loginWithMagicLinkToken(token);
      dispatch('loginWithShopToken', token);
    } catch {
      throw new Error('ShopTokenError');
    }
  },
  logout: ({ commit, dispatch }) => {
    commit(types.RESET);
  },
};
